import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../ApiEndpoint";



let initialState = {
    productdata: [],
    isLoading: false,
    isError: null,
};

//post api
export const addproduct = createAsyncThunk("postproduct", async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;

    // console.log(data, "datadatadatadata");

    try {
        const res = await axios.post(BASE_URL + endpoint, payload,);
        // console.log(res.data.product, "type post");

        return res.data.product;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//Get api
export const getproduct = createAsyncThunk("getproduct", async ({ endpoint }, { rejectWithValue }) => {
    try {
        let res = await axios.get(BASE_URL + endpoint,);
        // console.log(res.data.products, "res product get");
        return res.data.products;
    } catch (Error) {
        return rejectWithValue(Error.response ? Error.response.data : Error.message);
    }
});

//delete api
export const deleteproduct = createAsyncThunk("deleteproduct", async (data, { rejectWithValue }) => {
    let { endpoint, uuid } = data;
    try {
        await axios.delete(BASE_URL + endpoint + uuid);
        // console.log(res, "delete res");

        return uuid;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//updata api 
export const updateproduct = createAsyncThunk("updateproduct", async (data, { rejectWithValue }) => {
    let { endpoint, uuid, payload } = data;
    try {
        const res = await axios.put(BASE_URL + endpoint + uuid, payload,);
        // console.log(res.data.product, "resresres product updata");

        return res.data.product;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});



//slice
export const productdataSlice = createSlice({
    name: "product",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //post method
            .addCase(addproduct.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(addproduct.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload; // Store the error message
            })
            .addCase(addproduct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productdata.push(action.payload);
            })
            //get method
            .addCase(getproduct.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getproduct.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(getproduct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productdata = action.payload;
            })
            //delete method
            .addCase(deleteproduct.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(deleteproduct.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(deleteproduct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productdata = state.productdata.filter((item) => item.uuid !== action.payload);
            })
            //updata method
            .addCase(updateproduct.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(updateproduct.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(updateproduct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productdata = state.productdata.map((value) => value.uuid === action.payload.uuid ? action.payload : value);
            });

    },
});


export default productdataSlice.reducer;